export default __webpack_public_path__ + "static/media/payment-active.ab91d970.svg";